import React from "react";
import "./AudioPlayerLoader.css";

const AudioPlayerLoader = () => {
  return (
    <>
      <span className="audio-loader"></span>
    </>
  );
};

export default AudioPlayerLoader;
